import type { UnwrapNestedRefs } from "vue";
import type { Ref } from "vue";
export interface FetchApiInterface {
  (fetchAllData: any, fetchConf: any): Promise<any>;
}
// 前置的过滤方法，第一次过滤所有数据
export interface BeforeFetchDataFilterType {
  (res: unknown): unknown;
}

// 配置查询的数据过滤方法，在前置过滤支后
export interface FetchDataFilterType {
  (res: unknown): unknown;
}

//配置请求成功后返回的数据是否是成功数据
export interface IsSuccessType {
  (res: unknown): boolean;
}

//请求成功后的数据回调,res为返回数
export interface OnLoadDataSuccessType {
  (res: unknown): unknown;
}

// 配置返回的数据过滤方法,res返回的数据
export interface ResDataFilterType {
  (res: unknown): unknown;
}

// url方法请求类型,传入当前请求数据，返回请求方法
export interface UrlFunctionType {
  (fetchDataAll: unknown): string;
}

// 配置查询的方式类型
export interface FetchTypeConfType {
  GET: string;
  POST: string;
  PUT: string;
  DELETE: string;
}
// 支持的请求方式枚举
export const FetchTypeConf: FetchTypeConfType = {
  GET: "get",
  POST: "post",
  PUT: "put",
  DELETE: "delete",
};
export type FetchTypeConfKeyType = keyof typeof FetchTypeConf;

// 配置请求的数据的提交方式，可以为json或者form
export interface FetchDataTypeConfType {
  JSON: string;
  FORM: string;
}
// 支持的请求方式枚举
export const FetchDataTypeConf: FetchDataTypeConfType = {
  JSON: "json",
  FORM: "form",
};
export type FetchDataTypeConfKeyType = keyof typeof FetchDataTypeConf;

// 配置 一次查询多个接口数据的回调类型，是各自回调或是同一执行一个回调
export interface FetchListTypeConfType {
  ALL: "all";
  EVERY: "every";
}
export const FetchListTypeConf: FetchListTypeConfType = {
  ALL: "all",
  EVERY: "every",
};
export type FetchListTypeConfKeyType = keyof typeof FetchListTypeConf;
// 一个基础的请求配置成员项
export interface FetchDataConfType {
  name?: string;
  url?: string | UrlFunctionType;
  stateFetchData: UnwrapNestedRefs<unknown>;
  fetchData: UnwrapNestedRefs<unknown>;
  beforeFetchDataFilter: BeforeFetchDataFilterType;
  fetchDataFilter: FetchDataFilterType;
  fetchApi?: FetchApiInterface | boolean;
  fetchType: string;
  fetchDataType: string;
}
// 合并请求的数据结构
export interface MergeDataFilterType {
  success: boolean;
  data: any;
}
// 合并多个请求返回的数据结构
export interface MergeResponeDataType {
  confName: string;
  confIdx: number;
  data: any;
}
export interface LoadDataInterface {
  (): void;
}
export interface FindInfoOperateType {
  loading: Ref<boolean>;
  findInfoState: UnwrapNestedRefs<{ infoData: unknown }>;
  stateFetchData: UnwrapNestedRefs<unknown>;
  loadData: LoadDataInterface;
}
export interface AfterSuccessFuncType {
  (data: any): void;
}

export interface AfterErrorFuncType {
  (err: Error): void;
}
